import { render, staticRenderFns } from "./OrderDocuments.vue?vue&type=template&id=632d46ee&scoped=true"
import script from "./OrderDocuments.vue?vue&type=script&lang=ts"
export * from "./OrderDocuments.vue?vue&type=script&lang=ts"
import style0 from "./OrderDocuments.vue?vue&type=style&index=0&id=632d46ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632d46ee",
  null
  
)

export default component.exports